export const Save = {
  Id: "id" as const,
  Name: "name" as const,
  ReturnRelativeDates: "returnRelativeDates" as const,
  IsDefault: "isDefault" as const,
}

export const FilterBase = {
  SelectedFilter: "selectedFilter" as const,
}

